// extracted by mini-css-extract-plugin
module.exports = {"pause_all_button":"customerio-events-component-pause_all_button__1o1ot"};